import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';

export const Privacy = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 15, pb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Privacy Policy
      </Typography>

      <Typography variant="body1" paragraph sx={{ textIndent: '0.5in' }}>
        This policy applies to any person whose data is collected or processed
        ("Data Subjects") by Carcareers.com via the Carcareers.com website (
        <Link href="http://www.carcareers.com" target="_blank" rel="noopener">
          www.carcareers.com
        </Link>
        ) or the downloadable Carcareers.com software application and communicates 
        Carcareers.com's policy regarding the collection, use, disclosure and 
        processing of data collected from any Data Subject to protect their rights 
        in their personal data.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        1. Collection of Information
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com collects information from Data Subjects who visit the 
        Carcareers.com website or utilize the downloadable Carcareers.com software 
        application, either via the website visit itself, the voluntary supply of 
        form information, or social media interactions and other electronic communications. 
        Carcareers.com may collect information from visitors to its website using 
        cookies, server logs, and similar technologies.
      </Typography>

      <Typography variant="h6" component="h3" gutterBottom>
        1.1 Information Provided Voluntarily
      </Typography>

      <Typography variant="body1" paragraph>
        When you fill out a form or communicate directly with Carcareers.com, 
        Carcareers.com collects only the information you provide. Carcareers.com 
        will process this information to administer your account should you create one. 
        You should not provide information you regard as highly personal or sensitive 
        unless required for Carcareers.com to provide its services to you and you 
        agree to the terms of this Privacy Policy.
      </Typography>

      <Typography variant="h6" component="h3" gutterBottom>
        1.2 Information Collected Via the Website
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com may collect the following information from its website visitors:
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Log information, including browser type, the time, duration and frequency 
            of your visit, the pages viewed, hyperlinks accessed, messages, your IP 
            address and the page you visited before visiting the website.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Device information, including information identifying the device and 
            network used to access the website.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Your location information.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Data collected by cookies and pixel tags, as well as similar tracking means.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Other information, if your consent is given.
          </Typography>
        </Box>
      </Box>

      <Typography variant="h6" component="h3" gutterBottom>
        1.3 Information from Other Sources
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com may collect information about you from qualified resellers, 
        including social media websites, but only if you have given consent. 
        Carcareers.com may also collect information about you from publicly available sources.
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com may use and allow others to use cookies, beacons, device 
        identifiers, and other technologies to collect information about your use 
        of the website and other and online services.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        2. Use of Information
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com uses information about you to:
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">Operate its website.</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">Communicate with you.</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Send you updates you have requested based on your account preferences.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Meet its legal or contractual obligations, or protect its interests, 
            your interests or the interests of others.
          </Typography>
        </Box>
      </Box>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        3. Sharing of Information
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com only shares information about you:
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            through its website, according to your profile and settings;
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            with social media services, subject to the choices you may make via the website;
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            to third-party website service providers in furtherance of providing 
            information you have elected to receive;
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            to authorities to meet legal obligations and to protect and defend our 
            rights and property, as well as that of others, and
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            to any of our affiliate or successor entities as part of a corporate transaction.
          </Typography>
        </Box>
      </Box>

      <Typography variant="body1" paragraph>
        Carcareers.com partners with third-party websites in order to enhance the 
        services provided to you by Carcareers.com based on your account preferences. 
        When you visit any such third-party website, you will be subject to the terms 
        of the privacy policy associated with any such third-party website.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        4. Additional Details
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com may allow others to process your information on behalf of 
        Carcareers.com for the purpose of search engine optimization and other website 
        analytics. Carcareers.com is based in the United States and follows its laws 
        related to data privacy and security. You may be able to disable the collection 
        or use of this information.
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com uses commercially reasonable efforts to protect your personal 
        information and has internal policies and procedures designed to accomplish this. 
        Carcareers.com cannot, however, guarantee these controls will provide absolute security.
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com employs industry standard technical solutions designed to prevent 
        unauthorized access collection, use, disclosure, copying, modification or disposal 
        of your information. Carcareers.com stores all information that you provide on 
        secure servers and employs encryption technologies to protect your data. 
        Carcareers.com uses firewalls designed to protect against intruders and test 
        for network vulnerabilities, although these measures do not eliminate the threat 
        of a data breach.
      </Typography>

      <Typography variant="body1" paragraph>
        If you have a password that allows you to log into our website, you are 
        responsible for keeping it secure. If you would like to update or change your 
        password, you may go to your login page and follow the reset instructions.
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com may retain certain information collected from you:
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">so you can use the website;</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            to ensure that Carcareers.com does not communicate with you if you have opted out;
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">to provide you with a refund, if entitled;</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">to provide accurate accounting information;</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">to better understand the traffic to our website;</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            to detect and prevent abuse of our website, illegal activities and breaches 
            of our terms and conditions of service, and
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            to comply with applicable legal, tax or accounting requirements.
          </Typography>
        </Box>
      </Box>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        5. Your Choices
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            You can review and change information about you or deactivate your account 
            in your account settings, but Carcareers.com may retain certain information.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">You can remove photo tags.</Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            You can change Carcareers.com's ability to use your location information.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            You have the right to opt out of receiving messages from Carcareers.com.
          </Typography>
        </Box>
      </Box>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        6. Data Rights
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            You have the right to exercise your data protection rights, including to 
            request that Carcareers.com deletes, amends, or provides you access to your information.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            You have the right to opt out of receiving Carcareers.com's promotional 
            messages, but you may still receive other communications.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            You can complain to your local data protection authority about the use of your information.
          </Typography>
        </Box>
      </Box>

      <Typography variant="body1" paragraph>
        Other rights that you may have, depending on the country in which you live, include:
      </Typography>

      <Box component="ul" sx={{ pl: 3 }}>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Accessing, correcting, updating, or requesting deletion of your information.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Objecting to processing of your information, asking us to restrict processing 
            of your information, or requesting the portability of your information.
          </Typography>
        </Box>
        <Box component="li" sx={{ mb: 1 }}>
          <Typography variant="body1">
            Withdrawing your consent at any time if Carcareers.com has collected and 
            processed your information with your consent.
          </Typography>
        </Box>
      </Box>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        7. Minors
      </Typography>

      <Typography variant="body1" paragraph>
        Carcareers.com makes employment opportunities visible to prospective employees 
        who meet the requirements for becoming accepting such employment opportunities, 
        including any applicable age requirements. Carcareers.com is not intended for 
        use by any person under the age of 18 without the supervision of a parent or 
        legal guardian. Carcareers.com does not knowingly collect data from anyone under 
        the age of 13 years and shall promptly delete any such information collected 
        unknowingly upon discovery. If you believe Carcareers.com has obtained any 
        personal information from or about a person under the age of 13 years, please 
        contact{' '}
        <Link href="mailto:privacy@carcareers.com">privacy@carcareers.com</Link>.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        Contact Us
      </Typography>

      <Typography variant="body1" paragraph>
        If you have any questions, you can contact us at{' '}
        <Link href="mailto:privacy@carcareers.com">privacy@carcareers.com</Link>.
      </Typography>

      <Typography variant="body1" paragraph sx={{ mt: 3 }}>
        Last modified February 26, 2020.
      </Typography>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Contact Us:
        </Typography>
        <Typography variant="body1">CARCAREERS.COM LLC</Typography>
        <Typography variant="body1">2036 Carolina Place Drive, Fort Mill, SC 29708</Typography>
        <Typography variant="body1">
          <Link href="mailto:info@carcareers.com">info@carcareers.com</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Privacy;
